import { Menu } from "lucide-react";
import NotificationsBell from "./NotificationsBell";
import ViewAsControl from "./ViewAsControl";

interface TopBarProps {
  title: string;
  onMenuClick: () => void;
}

export default function TopBar({ title, onMenuClick }: TopBarProps) {
  return (
    <header className="flex h-14 items-center justify-between border-b border-gray-200 bg-white px-4 md:px-6">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 md:hidden"
          title="Open menu"
        >
          <Menu size={20} />
        </button>
        <span className="text-sm font-medium text-gray-700">{title}</span>
      </div>
      <div className="flex items-center gap-2">
        <ViewAsControl />
        <NotificationsBell />
      </div>
    </header>
  );
}
